export const batchAppend = pagesCount => ({
  type: 'BATCH_APPEND', pagesCount
});

export const currentPageSet = currentPage => ({
  type: 'CURRENT_PAGE_SET', currentPage
});

export const currentPageSetWithThunk = currentPage => (
  (dispatch) => {
    document.location.hash = `#page-${currentPage}`;
    dispatch(currentPageSet(currentPage));
  });

export const poppinsShow = () => ({
  type: 'POPPINS_SHOW'
});

export const openedPoppinToggle = id => ({
  type: 'OPENED_POPPIN_TOGGLE', id
});

export const openPoppinOnPage = (id, pageNumber) => (
  (dispatch) => {
    document.location.hash = `#page-${pageNumber}`;
    dispatch(poppinsShow());
    dispatch(openedPoppinToggle(id));
  }
);

export const fullscreenOff = () => ({
  type: 'FULLSCREEN_OFF'
});

export const fullscreenToggle = () => ({
  type: 'FULLSCREEN_TOGGLE'
});

export const openedPoppinClose = () => ({
  type: 'OPENED_POPPIN_CLOSE'
});

export const lastPageSetVisible = () => ({
  type: 'LAST_PAGE_SET_VISIBLE'
});

export const poppinsToggle = () => ({
  type: 'POPPINS_TOGGLE'
});

export const spinnerDontRender = () => ({
  type: 'SPINNER_DONT_RENDER'
});

export const spinnerHide = () => ({
  type: 'SPINNER_HIDE'
});

export const spinnerShow = () => ({
  type: 'SPINNER_SHOW'
});

export const zoomIn = () => ({
  type: 'ZOOM_IN'
});

export const zoomOut = () => ({
  type: 'ZOOM_OUT'
});
